import * as types from "../actions/types";
import _ from "lodash";

const clients = (
  state = {
    data: {},
    search: {
      data: [],
      total: 0,
    },
    clientData: {
      jobsSearch: {
        data: [],
        total: 0
      }
    }
  },
  action
) => {
  switch (action.type) {
    case types.SEARCH_CLIENTS: {
      return {
        ...state,
        data: { ...state.data, ..._.keyBy(action.payload.data, "_id") },
        search: {
          ...action.payload,
          data: action.payload.data.map((r) => r._id),
        },
      };
    }
    case types.CREATE_CLIENT:
    case types.FETCH_CLIENT:
    case types.UPDATE_CLIENT: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload._id]: action.payload
        }
      }
    }
    case types.DELETE_CLIENT: {
      const newSearchData = state.search.data.filter(id => id !== action.id);
      return {
        ...state,
        data: _.omit(state.data, action.id),
        search: {
          data: newSearchData,
          total: newSearchData.length !== state.search.data ? state.search.total - 1 : state.search.total,
        }
      }
    }
    default: {
      return state;
    }
  }
};

export default {
  clients,
};
